import React from 'react';
// import clsx from 'clsx'
import useCategories from 'sdk/hooks/useCategories';
import SelectWithModal from 'components/shared/SelectWithModal';

function CategorySelect({
  value, onChange, placeholder, className,
}: {
  value: any,
  onChange: (v: any) => void,
  placeholder?: string
  className?: string
}) {
  const categoriesData = useCategories()
  const getOptions = () => {
    const categories = categoriesData.data?.filter((c) => c.active != null)
    return [
      ...(categories || []),
    ]
  }

  return (
    <SelectWithModal
      className={className}
      options={getOptions()}
      title="Category"
      onSelect={onChange}
      placeholder={placeholder}
      value={value}
    />
  )
}

export default CategorySelect
